import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FlowTracker } from '@/components/analytics/FlowTracker';

// Automatic page view tracking for all routes
export default function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    // Extract page name from pathname (e.g., /elaftale -> Elaftale)
    const pageName = location.pathname === '/' ? 'Home' : 
      location.pathname.split('/').filter(Boolean)[0]?.replace(/-/g, ' ').replace(/^\w/, c => c.toUpperCase()) || 'Page';
    
    // Track page view
    FlowTracker.trackPageView(pageName, location.pathname);
  }, [location.pathname]);

  return null; // This component doesn't render anything
}